class KrealabModal{

    constructor(){
        KrealabModal.focusableSelector = 'button, a, input:not([type="hidden"]), textarea, select';
        KrealabModal.modal = null;
        KrealabModal.focusables = [];
        KrealabModal.previouslyFocusedElement = null;

        document.querySelectorAll("a.kl-modal-opener, li.kl-modal-opener > a").forEach(e => {
            e.addEventListener("click", this.openModal)
        }), window.addEventListener("keydown", function(e) {
            "Escape" !== e.key && "Esc" !== e.key || KrealabModal.closeModal(e), "Tab" === e.key && null !== KrealabModal.modal && KrealabModal.focusInModal(e)
        });
    }

    openModal(e){
        e.preventDefault();
        let s = jQuery(this).attr('href');

        KrealabModal.modal = document.querySelector(s);
        if(!KrealabModal.modal) return;

        KrealabModal.focusables = Array.from(KrealabModal.modal.querySelectorAll(KrealabModal.focusableSelector));
        KrealabModal.previouslyFocusedElement = document.querySelector(":focus");
        KrealabModal.modal.classList.add('active');
        KrealabModal.focusables[0].focus();

        KrealabModal.modal.removeAttribute('aria-hidden');
        KrealabModal.modal.setAttribute('aria-modal', true);
        KrealabModal.modal.addEventListener('click', KrealabModal.closeModal);
        KrealabModal.modal.querySelector('.kl-modal-close').addEventListener('click', KrealabModal.closeModal);
        KrealabModal.modal.querySelector('.inner').addEventListener('click', KrealabModal.stopPropagation);
    }

    static closeModal(e){
        if(null === KrealabModal.modal) return;
        null !== KrealabModal.previouslyFocusedElement && KrealabModal.previouslyFocusedElement.focus();
        e.preventDefault();
        KrealabModal.modal.classList.remove('active');
        KrealabModal.modal.setAttribute('aria-hidden', true);
        KrealabModal.modal.removeAttribute('aria-modal', false);
        KrealabModal.modal.removeEventListener('click', KrealabModal.closeModal);
        KrealabModal.modal.querySelector('.kl-modal-close').removeEventListener('click', KrealabModal.closeModal);
        KrealabModal.modal.querySelector('.inner').removeEventListener('click', KrealabModal.stopPropagation);
    }

    static keyboard(e){
        "Escape" !== e.key && "Esc" !== e.key || KrealabModal.closeModal(e);
        "Tab" === e.key && null !== KrealabModal.modal && KrealabModal.focusInModal(e);
    }

    static focusInModal(e){
        e.preventDefault();
        let o = KrealabModal.focusables.findIndex(KrealabModal.FindIndex);
        e.shiftKey ? o-- : o++;
        o >= KrealabModal.focusables.length && (o = 0);
        o < 0 && (o = KrealabModal.focusables.length - 1);

        KrealabModal.focusables[o].focus();
    }

    static stopPropagation(e){
        e.stopPropagation();
    }

    static FindIndex(element){
        return element === KrealabModal.modal.querySelector(":focus");
    }
}

export default KrealabModal;